import ServiceGraphQL from 'src/service/gql-service';
import { getCompanyRoles } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const GetCompanyRoles = (_id) => {
  const params = {
    query: getCompanyRoles.QUERY,
    variables: {
      _id
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
